<div class="main-container">
  <div class="sidebar">
    @if (pinnedQueries().length) {
      <div class="pinned-section">
        <div class="pinned-header" (click)="togglePinnedSection()">
          <h3>
            Pinned Questions
          </h3>
          <button
            mat-icon-button
            type="button"
            class="pinned-toggle-btn"
            (click)="togglePinnedSection($event)"
            [attr.aria-expanded]="pinnedExpanded()"
            [attr.aria-label]="pinnedExpanded() ? 'Collapse pinned questions' : 'Expand pinned questions'">
            <mat-icon>{{ pinnedExpanded() ? 'remove' : 'add' }}</mat-icon>
          </button>
        </div>
        @if (pinnedExpanded()) {
          <div class="pinned-list">
            @for (pinned of pinnedQueries(); track pinned.id) {
              <div
                class="pinned-item"
                (click)="usePinnedQuery(pinned)"
                [matTooltip]="pinned.text"
                matTooltipShowDelay="400">
                <mat-icon class="pinned-icon">push_pin</mat-icon>
                <span class="pinned-text">{{ truncatePinnedText(pinned.text) }}</span>
                <button
                  mat-icon-button
                  type="button"
                  class="unpin-btn"
                  (click)="unpinQuery($event, pinned)"
                  [disabled]="pinnedQueryService.isMutating()"
                  aria-label="Unpin question">
                  <mat-icon>close</mat-icon>
                </button>
              </div>
            }
          </div>
        }
      </div>
    }

    <div *ngIf="groupedSessions().length && !isShortGroupedChatsLoading()" class="container">
      <div
           *ngFor="let sessionsGroup of groupedSessions()">
        <div>
          <h3>{{ sessionsGroup.relativeDate }}</h3>
          <div>
            <div class="session" *ngFor="let session of sessionsGroup.sessions">
              @if (session) {
                <div class="session-container"
                      [class.selected]="session.id === currentChat" (click)="openChat(session)">
                  <span  class="session-name">{{ getSessionDisplayName(session) }}</span>
                </div>
              }
            </div>
          </div>
        </div>

      </div>

    </div>
    <div class="loader" *ngIf="isShortGroupedChatsLoading()">
      <mat-spinner diameter="48" strokeWidth="3" color="accent"></mat-spinner>
    </div>
    <div class="header-text" *ngIf="!groupedSessions().length && !isShortGroupedChatsLoading() && !pinnedQueries().length">
      <h5>No conversations found</h5>
      <p class="subtitle">Start a new conversation to get started</p>
    </div>
  </div>
</div>
